import './content-share'
import './google-map'

$.fn.InfiniteScroll_Footer = function(infinite_scroll) {
  let self = this
  self.map = undefined

  if (self.data('infinite-scroll-footer')) {
    return self.data('infinite-scroll-footer')
  }

  self.arrow_prev = self.find('.content-navigation__prev')
  self.arrow_next = self.find('.content-navigation__next')

  self.toggle_map = function() {
    if (self.find('.content-map').attr('aria-hidden') === 'true') {
      self.find('.content-map').attr('aria-hidden', 'false')
      self.find('.content-footer__location-btn').attr('aria-expanded', 'true')
    } else {
      self.find('.content-map').attr('aria-hidden', 'true')
      self.find('.content-footer__location-btn').attr('aria-expanded', 'false')
    }
  }

  self.initialize_share = function() {
    self.find('.content-share').ContentShare()
  }

  self.initialize_map = function() {
    if (self.map == undefined && self.find('.content-map__google-map').length) {
      self.map = self.find('.content-map__google-map').GoogleMap()
      self.find('.content-footer__location-btn').on('click', self.toggle_map)
    }
    if (self.map != undefined) {
      self.map.setCenter(self.map.data('lat'), self.map.data('lng'))
    }
  }

  self.update = function(new_footer) {
    self.find('.content-footer__more').replaceWith(new_footer.find('.content-footer__more').clone())
    self.find('.content-share__action--facebook').attr('href', new_footer.find('.content-share__action--facebook').attr('href'))
    self.find('.content-share__action--facebook').attr('onclick', new_footer.find('.content-share__action--facebook').attr('onclick'))
    self.find('.content-share__action--mail').attr('href', new_footer.find('.content-share__action--mail').attr('href'))
    if (self.map == undefined && self.find('.content-map__google-map').length) {
      self.map = self.find('.content-map__google-map').GoogleMap()
      self.find('.content-footer__location-btn').on('click', self.toggle_map)
    }
    if (self.map != undefined) {
      self.map.setCenter(new_footer.find('.content-map__google-map').data('lat'), new_footer.find('.content-map__google-map').data('lng'))
    }
    if (infinite_scroll != undefined) {
      self.arrow_prev.prop('disabled', !infinite_scroll.current_content.prev('.content').length)
      self.arrow_next.prop('disabled', !infinite_scroll.current_content.next('.content').length)
    }
  }

  self.show_navigation = function() {
    self.find('.content-navigation').attr('aria-hidden',  'false')
  }

  self.initialize = function() {
    self.initialize_share()
    self.initialize_map()
    if (infinite_scroll != undefined) {
      self.arrow_next.on('click', infinite_scroll.go_next)
      self.arrow_prev.on('click', infinite_scroll.go_prev)
    }
    return self
  }

  return function() {
    self.data('infinite-scroll-footer', self)
    return self
  }()
}

$.fn.InfiniteScroll_Item = function() {
  let self = this

  if (self.data('infinite-scroll-item')) {
    return self.data('infinite-scroll-item')
  }

  self.url = self.data('url')
  self.format = self.data('format')
  self.json_ld = undefined
  self.id = self.data('id')
  self.key_str = undefined
  self.was_detached = false

  self.key = function() {
    if (self.key_str == undefined) {
      self.key_str = 'content_' + self.id
    }
    return self.key_str
  }

  self.detach_content = function() {
    self.attr('aria-hidden', 'true')
    self.originalTitle.replaceWith(self.replacementTitle)
    self.was_detached = true
  }

  self.attach_content = function() {
    self.attr('aria-hidden', 'false')
    if (self.was_detached) {
      self.replacementTitle.replaceWith(self.originalTitle)
    }
  }

  return function() {
    if (self.find('.schema-graph').length) {
      self.json_ld = JSON.parse(self.find('.schema-graph').html())
    }
    let title = self.find('h1')
    self.originalTitle = title
    self.replacementTitle = $('<p>').addClass(title.attr('class')).html(title.text())
    self.data('infinite-scroll-item', self)
    return self
  }()
}

$.fn.InfiniteScroll = function(options) {
  let self = this

  if (self.data('infinite-scroll')) {
    return self.data('infinite-scroll')
  }

  self.options = $.extend(true, {
    onLoad: undefined,
  }, options)

  self.first_content = self.find('.content[data-url]').InfiniteScroll_Item()
  self.last_content = self.first_content
  self.current_content = self.first_content
  self.footer = self.first_content.find('.content-footer').clone().InfiniteScroll_Footer(self)
  self.ids = [];
  self.content = {}
  self.format = self.first_content.data('format')
  self.is_transitioning = false
  // self.is_popping = false

  self.load_next = function(url) {
    $.get(url, function(x) {
      let loadedContent =  $('<html>').html(x).find('.content[data-url]')
      loadedContent.each(function() {
        let content = $(this).InfiniteScroll_Item()
        if ($.inArray(content.id, self.ids) === -1) {
          self.ids.push(content.id)
          self.footer.show_navigation()
          self.content[content.key()] = content
          self.last_content.after(content)
          self.last_content = content
          if (self.options.onLoad != undefined) {
            self.options.onLoad(content)
          }
          content.detach_content()
        }
      })
    })
  }

  self.go_prev = function() {
    if (self.current_content.prev('.content').length) {
      if (self.is_transitioning) {
        self.transition_buffer = 'prev'
        return
      }
      self.is_transitioning = true
      let currentTop = self.current_content.offset().top,
      cutoff = $(window).height() - $('.content-footer').outerHeight(false) - $('.header').outerHeight(false) - $('.format-menu').outerHeight(false) + 4
      if (currentTop < $('.header').outerHeight(false) + $('.format-menu').outerHeight(false) + 5) {
        self.current_content.prev('.content').css({
          height: cutoff + 'px',
        })
        let targetTop = self.current_content.offset().top + $.mlmi.scroller.scrollTop() - currentTop
        $.mlmi.scroller.scrollTop(targetTop)
      }
      requestAnimationFrame(function() {
        let targetTop = self.current_content.prev('.content').offset().top + $.mlmi.scroller.scrollTop() - $('.header').outerHeight(false) - $('.format-menu').outerHeight(false)
        $.mlmi.scroller.scrollTo(targetTop, 450, 4, 'easeInOutQuart', function() {
          self.current_content.css({
            height: '',
          })
          self.is_transitioning = false
          requestAnimationFrame(function() {
            if (self.transition_buffer == 'next') {
              self.go_next()
            } else if (self.transition_buffer == 'prev') {
              self.go_prev()
            }
            self.transition_buffer = false
          })
        })
      })
    }
  }

  self.go_next = function() {
    if (self.current_content.next('.content').length) {
      if (self.is_transitioning) {
        self.transition_buffer = 'next'
        return
      }
      self.is_transitioning = true
      let currentTop = self.current_content.offset().top,
      currentBottom = currentTop + self.current_content.outerHeight(false),
      cutoff = -currentTop + $(window).height() - $('.content-footer').outerHeight(false)
      if (currentBottom > $(window).height()) {
        self.current_content.css({
          height: cutoff + 'px',
        })
      }
      requestAnimationFrame(function() {
        let targetTop = self.current_content.next('.content').offset().top + $.mlmi.scroller.scrollTop() - $('.header').outerHeight(false) - $('.format-menu').outerHeight(false)
        $.mlmi.scroller.scrollTo(targetTop, 450, 4, 'easeInOutQuart', function() {
          self.current_content.prev('.content').css({
            height: '',
          })
          let targetTop = self.current_content.offset().top + $.mlmi.scroller.scrollTop() - $('.header').outerHeight(false) - $('.format-menu').outerHeight(false)
          $.mlmi.scroller.scrollTop(targetTop)
          self.is_transitioning = false
          requestAnimationFrame(function() {
            if (self.transition_buffer == 'next') {
              self.go_next()
            } else if (self.transition_buffer == 'prev') {
              self.go_prev()
            }
            self.transition_buffer = false
          })
        })
      })
    }
  }

  self.scrolled = function(top, direction) {
    let viewed_content = self.current_content

    for (let key in self.content) {
      let content = self.content[key]
      if (direction == 'down' && top > (content.offset().top + top) - $(window).height() + $('.app > .content-footer').outerHeight(false)) {
        viewed_content = content
      } else if (direction == 'up' && content.offset().top < $(window).height() && top < content.find('.related-content').offset().top + top - $('.header').outerHeight(false) - $('.format-menu').outerHeight(false) + 4) {
        viewed_content = content
      }
    }

    if (self.current_content.data('url') != viewed_content.data('url')) {
      /* New content */
      self.current_content.detach_content()
      self.current_content = viewed_content
      self.current_content.attach_content()

      /* New footer */
      let new_footer = self.current_content.find('.content-footer')
      self.footer.update(new_footer)

      /* History change */
      if ('history' in window) {
        if (self.is_popping) {
          self.is_popping = false
        } else {
          document.title = self.current_content.data('title')
          if (location.hostname != 'localhost') {
            $.mlmi.navigation.pushState({
              infiniteScroll: true,
              infiniteScrollURL: self.current_content.data('url'),
              infiniteScrollTitle: self.current_content.data('title'),
            }, '', self.current_content.data('url'))
          }
        }
      }
    }
  }

  return function() {
    // if ('history' in window) {
      // if (location.hostname != 'localhost') {
      //   history.scrollRestoration = 'manual'
      //   history.replaceState({
      //     infiniteScroll: true,
      //     infiniteScrollContent: self.current_content,
      //   }, '', self.current_content.url)
      // }
      // $(window).on('popstate', function(e) {
      //   let popState = e.originalEvent.state
      //   if (popState != null && 'infiniteScroll' in popState && popState.infiniteScroll) {
      //     let target = $('.content[data-url="' + popState.infiniteScrollURL + '"]')
      //     if (target.length) {
      //       e.preventDefault()
      //       self.is_popping = true
      //       document.title = popState.infiniteScrollTitle
      //       $('html, body').scrollTo(target.offset().top, 350, 4, 'easeInOutQuart')
      //     }
      //   }
      // })
    // }
    self.ids.push(self.first_content.id)
    self.content[self.first_content.key()] = self.first_content
    self.first_content.attach_content()
    self.load_next('/format/' + self.format + '/')
    $.mlmi.scroller.add(self.scrolled)
    $('.content__wrapper').after(self.footer.initialize())
    self.data('infinite-scroll', self)
    $(window).on('wheel', function() {
      self.is_transitioning = false
      self.transition_buffer = false
    })
    return self
  }()
}
